// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Types
import type { ChartType } from '@/lib/analytics/charts/type';
import { SIZE_50 } from '@/lib/gridElements/size';
import { YOUTUBE } from '@/lib/socialProfile';

// Components
import { BarGroupedChart } from '@/components/composite/Charts/BarGroupedChart';

export const postHistoryConfig: ChartType<typeof BarGroupedChart> = {
    title: 'chart.youtube.post_history',
    tooltip: 'chart.youtube.post_history_tooltip',
    id: 'post_history',
    margin: { left: -30, bottom: 25, right: 10 },
    name: {
        date: 'date',
        value: 'chart.youtube.post_history_name'
    },
    social: YOUTUBE,
    color: {
        value: 'blue'
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    type: 'chart',
    isXAxisDate: true,
    element: BarGroupedChart
};
